export const workorderImportDicionary: Record<string, string> = {
  'workorder.errors.workorder_stock_query_fail': 'Importação não encontrada',
  'enterprise.errors.cilia_token_not_found_in_company':
    'Token de importação Cilia inválido',
};
